export enum EpledgesRoutingEnum {
  EPLEDGES = "/epledges",
  PLEDGE_REQUEST = "/pledge-request",
  REQUEST_STATUS = "/request-status",
  REDIRECT = "/epledges/redirecting",
}

const routeList: any = [
  "/search",
  "/edis",
  // "/markets/futures",
  // "/markets/options",
  "/fund-transfer",
  "/watchlist",
  "/watchlist/LIST",
  "/editwatchlist",
  EpledgesRoutingEnum.EPLEDGES,
  EpledgesRoutingEnum.PLEDGE_REQUEST,
  EpledgesRoutingEnum.REQUEST_STATUS,
  EpledgesRoutingEnum.REDIRECT,
  "/newreports/positions",
  "/margin-calculator",
  "/orderbook",
  "/newreports",
  "/reports",
  "/options",
  "/option-chain-tool",
  "/trading-view",
];
export const chatBotManager = (route?: string, isSidebar?: boolean) => {
  let result = true;
  if (isSidebar) {
    return (result = false);
  } else {
    return (result =
      routeList?.filter((el: string) => route?.includes(el))?.length > 0
        ? false
        : true);
  }
};
